export default __webpack_public_path__ + "maps-guides-styles-layers-fill-extrusion-layer-960-8925bdbd83488d3d043e231ff8d5a1e6.png";